import React from 'react';
import { BillingPortalStateContext } from '../providers/BillingPortalStateProvider';

export interface BillingPortalBannerStateType {
  displaySuccessMessage: boolean;
}

export const useBanner = () => {
  const [bannerState, setBannerState] = React.useState<BillingPortalBannerStateType>({ displaySuccessMessage: false });

  return {
    bannerState,
    setBannerState,
  };
};

export const useAppBanner = () => {
  const billingPortalState = React.useContext(BillingPortalStateContext);

  if (!billingPortalState) throw new Error('State Not initialized');

  return billingPortalState.bannerState;
};
